import React, { useRef, useState } from "react";
import classNames from "classnames/bind";
import {
  SelectBox,
  SelectBoxItem,
  InputTextBox,
} from "../../../../components";
import { SearchBlack } from "../../../../components/Icons/Icons";
import styles from "./Filter.module.css";

const cx = classNames.bind(styles);

const Filter = ({
  setSearch,
  isRefresh,
  setIsRefresh,
  onChangeDayEnd,
  onChangeDayStart,
  dayEnd,
  dayStart,
}) => {
  const ref = useRef();
  const [input, setInput] = useState();
  const onChangeTextSearch = (e) => {
    setInput(e.target.value);
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      const data = e.target.value;
      setSearch(data);
      setIsRefresh(!isRefresh);
    }, 300);
  };
  return (
    <div className={cx("filter")}>
      <div className={cx("search")}>
        <input
          value={input}
          onChange={onChangeTextSearch}
          className={cx("search-input")}
          placeholder="Tìm kiếm..."
        />
        <span className={cx("icon-search")}>
          <SearchBlack />
        </span>
        {/* <SearchIcon/> */}
      </div>
      <div style={{ paddingTop: 20 }}>
        <label className={cx("label")}>Trạng thái</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          styles={{ width: "100%" }}
        >
          <SelectBoxItem label="Tất cả" value="all" />
          <SelectBoxItem label="Chờ xác nhận" value="On" />
          <SelectBoxItem label="Tài khoản bị khóa" value="Off" />
        </SelectBox>
      </div>
      <div>
        <InputTextBox
          size={"small"}
          type={"date"}
          title={"Từ ngày"}
          onChange={onChangeDayStart}
          value={dayStart}
        />
      </div>

      <div>
        <InputTextBox
          size={"small"}
          type={"date"}
          title={"Đến ngày"}
          onChange={onChangeDayEnd}
          value={dayEnd}
        />
      </div>
    </div>
  );
};

export default Filter;
